import React, { useRef, useState } from 'react';
import { Check, ChevronsRight } from 'lucide-react';
import { useTranslation } from '../i18n/LocaleContext';

const KNOB = 44;

// 前端滑块人机验证:后端注册接口不校验验证码,这里挡的是脚本直刷表单。
// 一次通过即保持已验证;要重新验证由父组件重挂载本组件。
const SliderCaptcha = ({ onVerified }) => {
  const { t } = useTranslation();
  const trackRef = useRef(null);
  const dragFrom = useRef(0);
  const [x, setX] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [done, setDone] = useState(false);

  const maxLeft = () => (trackRef.current?.clientWidth || 0) - KNOB - 4;

  const handlePointerDown = (e) => {
    if (done) return;
    setDragging(true);
    dragFrom.current = e.clientX - x;
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const handlePointerMove = (e) => {
    if (!dragging || done) return;
    setX(Math.min(Math.max(e.clientX - dragFrom.current, 0), maxLeft()));
  };

  const handlePointerUp = () => {
    if (!dragging) return;
    setDragging(false);
    if (x >= maxLeft() - 4) {
      setDone(true);
      onVerified?.(true);
    } else {
      setX(0);
    }
  };

  return (
    <div
      ref={trackRef}
      className={`relative h-[52px] rounded-xl border bg-canvas overflow-hidden select-none ${
        done ? 'border-brand-500' : 'border-black/[0.08]'
      }`}
    >
      <div
        className={`absolute inset-y-0 left-0 ${dragging ? '' : 'transition-all duration-200'} ${
          done ? 'bg-brand-500' : 'bg-brand-100'
        }`}
        style={{ width: x + KNOB }}
      />
      <p
        className={`absolute inset-0 flex items-center justify-center text-[13px] font-semibold pointer-events-none px-16 ${
          done ? 'text-white' : 'text-ink-muted'
        }`}
      >
        {done ? (
          <>
            <Check className="w-4 h-4 mr-1.5" strokeWidth={2.6} />
            {t('captchaVerified')}
          </>
        ) : (
          <>
            {t('captchaSlideToVerify')}
            <ChevronsRight className="w-4 h-4 ml-1" strokeWidth={2.4} />
          </>
        )}
      </p>
      <div
        role="button"
        aria-label={t('captchaSlideToVerify')}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerCancel={handlePointerUp}
        className={`absolute top-0.5 left-0.5 w-[44px] h-[44px] rounded-[10px] bg-white shadow-md
          flex items-center justify-center touch-none
          ${dragging ? 'cursor-grabbing' : 'cursor-grab'} ${done ? 'cursor-default' : ''}`}
        style={{
          transform: `translateX(${x}px)`,
          transition: dragging ? 'none' : 'transform 0.2s ease'
        }}
      >
        {done ? (
          <Check className="w-5 h-5 text-brand-600" strokeWidth={2.6} />
        ) : (
          <ChevronsRight className="w-5 h-5 text-brand-500" strokeWidth={2.4} />
        )}
      </div>
    </div>
  );
};

export default SliderCaptcha;
